// HandHygieneForm.js
import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import NotesSection from './hand_hygiene_notes_section';
import OperatorList from './hand_hygiene_operator_list';
import MainDataSection from './hand_hygiene_maindata_section';
import { useTranslation } from 'react-i18next';

const HandHygieneForm = forwardRef(({
    sheet,
    vocabs,
    config,
    sheetNumber,
    filterAreasByDepartment,
    filterDepartmentsByAuthority,
    onDataChange
}, ref) => {
    // Refs for collecting data from components
    const operatorListRef = useRef();
    const mainDataRef = useRef();
    const notesRef = useRef();
    const { t } = useTranslation(['labels']);
    // Expose data collection method to parent
    useImperativeHandle(ref, () => ({
        getData: () => {
            // Collect data from all sections
            const operatorsData = operatorListRef.current?.getData() || [];
            const mainData = mainDataRef.current?.getData() || {};
            const notesData = notesRef.current?.getData() || {};

            return {
                ...sheet,
                ...mainData,
                ...notesData,
                ObservedOperators: operatorsData
            };
        }
    }));

    return (
        <>
            <div className="card-header">
                <h4 className="heading mb-0">
                    {t("handHygiene", { ns: "labels" })}: {sheetNumber}
                </h4>
            </div>

            <div className="card-body">
                <div className="row mb-3">

                    <div className="col-lg-12 mb-3">
                        <MainDataSection
                            ref={mainDataRef}
                            sheet={sheet}
                            vocabs={vocabs}
                            filterAreasByDepartment={filterAreasByDepartment}
                            filterDepartmentsByAuthority={filterDepartmentsByAuthority}
                            onDataChange={onDataChange}
                        />
                    </div>

                    <div className="col-lg-12 mb-3">
                        <OperatorList
                            ref={operatorListRef}
                            operators={sheet.ObservedOperators}
                            vocs={vocabs.operators}
                            config={config}
                            onDataChange={onDataChange}
                        />
                    </div>
                </div>

                <NotesSection
                    ref={notesRef}
                    sheet={sheet}
                    config={config}
                    onDataChange={onDataChange}
                />
            </div>
        </>
    );
});

export default HandHygieneForm;
